/**
* hero slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the hero slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import ScrollMagic from 'ScrollMagic';
// import animationGSAP from 'animation.gsap';
// import addIndicators from 'debug.addIndicators';
// import TweenMax from 'TweenMax';
// import TimelineMax from 'TimelineMax';
( function( app ) {
  const COMPONENT = {

    className: 'hero-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.hero-slider' ).each( function( index, el ) {
        const mainSlider = $( el ).find( '.slider-main' );
        const secondarySlider = $( el ).find( '.slider-secondary' );
        const magicLine = $( el ).find( '.magic-line' );

        mainSlider.on( 'init', function( event, slick ) {
          const lineWidth = $( el ).find( '.hero-slider-nav button.active' ).parent().outerWidth();
          const activeSlideButton = $( el ).find( 'button.active' );
          const buttonLeftPos = activeSlideButton.position().left;
          magicLine.css( 'width', lineWidth );
          magicLine.stop().animate( {
            left: buttonLeftPos,
          } );
        } );

        mainSlider.slick( {
          arrows: false,
          dots: true,
          fade: true,
          speed: 0,
          draggable: true,
          autoplay: true,
          autoplaySpeed: 5000,
          asNavFor: $( el ).find( '.slider-secondary' ),
          pauseOnHover: false,
          pauseOnFocus: false,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                draggable: false,
                dots: false,
              },
            },
          ],
        } );

        secondarySlider.slick( {
          arrows: false,
          dots: false,
          fade: true,
          speed: 1000,
          draggable: false,
          pauseOnHover: false,
          pauseOnFocus: false,
        } );

        mainSlider.on( 'afterChange', function( event, slick, currentSlide ) {
          const activeSlideButton = $( el ).find( 'button[data-slide="'+currentSlide+'"]' );
          const currentSlideMediaEl = secondarySlider.find( '.slick-slide[data-slick-index="'+currentSlide+'"]' );
          const slideVideo = currentSlideMediaEl.find( '.loop-video' );
          const buttonLeftPos = activeSlideButton.position().left;
          activeSlideButton.addClass( 'active' );
          magicLine.stop().animate( {
            left: buttonLeftPos,
          } );

          /*
           * if there's a video in the slide,
           * start it
           */
          if ( slideVideo.length ) {
            slideVideo.get( 0 ).play();
          }
        } );

        mainSlider.on( 'beforeChange', function( event, slick, currentSlide, nextSlide ) {
          $( el ).find( 'button.active' ).removeClass( 'active' );
          const currentSlideMediaEl = secondarySlider.find( '.slick-slide[data-slick-index="'+currentSlide+'"]' );
          const slideVideo = currentSlideMediaEl.find( '.loop-video' );
          const group = mainSlider.find( '.slick-slide[data-slick-index="'+nextSlide+'"] .wysiwyg' ).children();
          group.each( function( index, item ) {
            $( item ).css( {
              transitionDelay: ( ( index / group.length ) + 0.5 ) + 's',
            } );
          } );

          /*
           * If there's a video in the slide, stop it
           */
          if ( slideVideo.length ) {
            slideVideo.get( 0 ).pause();
          }
        } );
      } );

      $( '.hero-slider .js-slide-control' ).click( function( e ) {
        const slider = $( this ).closest( '.hero-slider' ).find( '.slider-main, .slider-secondary' );
        const slideIndex = $( this ).data( 'slide' );
        slider.slick( 'slickGoTo', slideIndex );
      } );

      $( '.hero-slider .js-slide-control' ).on( 'keydown', function( e ) {
        const slider = $( this ).closest( '.hero-slider' ).find( '.slider-main, .slider-secondary' );
        switch ( e.keyCode ) {
          case 37:
            slider.slick( 'slickPrev' );
            break;
          case 39:
            slider.slick( 'slickNext' );
            break;
          default:
            return;
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'hero-slider', COMPONENT );
} )( app );
